import { QuoteResponse } from "@/main/models/response";
import { ProcurementStatusEnum } from "@/main/services/enum/StatusProcurement";

import { TypeCreateOrderBodyshopStep } from "./types";

export const STEPS_CREATE_ORDER_BODYSHOP: TypeCreateOrderBodyshopStep[] = [
	"VehicleData",
	"DamageArea",
	"DamageParts",
	"Summary",
];

export function getStepsBefore(step: TypeCreateOrderBodyshopStep): TypeCreateOrderBodyshopStep[] {
	return STEPS_CREATE_ORDER_BODYSHOP.slice(0, STEPS_CREATE_ORDER_BODYSHOP.indexOf(step));
}

const STATUSES_LOCKING_STEP_NAVIGATION: number[] = [ProcurementStatusEnum.Manual, ProcurementStatusEnum.Cancelled];

export function isStepNavigationLockedByStatus(idProcurementStatus: number | null): boolean {
	return idProcurementStatus !== null && STATUSES_LOCKING_STEP_NAVIGATION.includes(idProcurementStatus);
}

export function getStepByQuoteDetail(result: QuoteResponse): TypeCreateOrderBodyshopStep {
	const isLocked = isStepNavigationLockedByStatus(result.idProcurementStatus);

	return isLocked || result.hasQuoteItem ? "Summary" : "VehicleData";
}
